import TemplateReducer from "./template/reducer";

export { TemplateReducer };
